import { COLOR_WH_10 } from '../colors.constants';

export const colorsSearch = {
  colorSearchBorder: COLOR_WH_10,
  colorSearchBackground: COLOR_WH_10,
};
